export default __webpack_public_path__ + "static/media/Player 2 - Onwards.a3355983.mp3";